import { render, staticRenderFns } from "./RegionFilterForm.vue?vue&type=template&id=24170474"
import script from "./RegionFilterForm.vue?vue&type=script&setup=true&lang=js"
export * from "./RegionFilterForm.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports